import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import checkTokenMiddleware from './redux/middleware/checkToken';
import listingReducer from './redux/reducers/listing';
import listingsReducer from './redux/reducers/listings';
import shareReducer from './redux/reducers/share';
import snackbarReducer from './redux/reducers/snackbar';
import userReducer from './redux/reducers/user';
import dashboardReducer from './redux/reducers/dashboard';
import Dashboard from './components/Dashboard';

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const rootReducer = combineReducers({
    listing: listingReducer,
    listings: listingsReducer,
    share: shareReducer,
    snackbar: snackbarReducer,
    user: userReducer,
    dashboard: dashboardReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk, checkTokenMiddleware)
));
window.store = store
ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <BrowserRouter>
                <Switch>
                    {/* Separating App and Dashboard routes from each other */}
                    <Route exact path="/dashboard/listing/:ekey/:id" >
                        <Dashboard/>
                    </Route>
                    <Route>
                        <App />
                    </Route>
                </Switch>
            </BrowserRouter>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
